export default "<p>\n  dashboard works!\n</p>\n<app-maps></app-maps>\n"